import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Button, Modal } from '@mui/material'

import { RootState } from '../../appReducer'
import { useAppDispatch } from '../../util/useAppDispatch'

import { saveAdmin, sendPasswordReset, unlockAccount, updateAdminUnlockedStatus } from './actions'
import ManageAdmin from './ManageAdmin'

import './AdminItem.sass'

type Props = {
    admin: Models.Account
}

const AdminItem = (props: Props) => {
    const { admin } = props
    const [showModal, setShowModal] = useState(false)
    const dispatch = useAppDispatch()

    const permissions = useSelector((state: RootState) => state.admin.permissions)

    useEffect(() => {
        if (showModal) {
            document.body.style.overflowY = 'hidden'
            return
        }
        document.body.style.overflowY = 'initial'
    }, [showModal])

    const onShowModal = () => {
        setShowModal(true)
    }

    const onCloseModal = () => {
        setShowModal(false)
    }

    return (
        <>
            {showModal && (
                <Modal
                    className="pst-modal"
                    open={true}
                    onClose={(event, reason) => {
                        if (reason !== 'backdropClick') {
                            onCloseModal()
                        }
                    }}
                    disableEscapeKeyDown={true}
                >
                    <div className="contents manage-admin-modal">
                        <div className="close-modal-button" onClick={onCloseModal}>
                            <i className="material-icons">close</i>
                        </div>
                        <ManageAdmin
                            admin={admin}
                            permissionList={permissions}
                            submitButtonText="Update"
                            onClose={onCloseModal}
                            onSave={(changes: Api.AccountUpdate) => {
                                dispatch(saveAdmin(admin, changes)).then(() => {
                                    onCloseModal()
                                })
                            }}
                            onSendPasswordReset={() => dispatch(sendPasswordReset(admin))}
                            onUnlockAccount={() => dispatch(unlockAccount(admin))}
                            updateStatusOnUnlockAccount={(adminId: string) =>
                                dispatch(updateAdminUnlockedStatus(adminId))
                            }
                        />
                    </div>
                </Modal>
            )}
            <Button onClick={onShowModal}>Manage</Button>
        </>
    )
}

export default AdminItem
